import { Input, Output, EventEmitter, Directive } from '@angular/core';

import { Partition } from '@classes/simulation/partition';

@Directive()
export class PartitionsTreeBase {
    @Input() partitions: Partition[];
    @Input() selectedNode: Partition;
    @Input() isMultiple = false;
    @Input() allowMultiCategories = false;
    @Output() toggleSelection = new EventEmitter<string[]>();

    constructor() {}
}
